import { Slot } from "./Slot"

export class Video extends Slot {
  get id () { return 'video' } 
}
